import React, { useState } from 'react';
import { colors } from '../styles/colors';
import { fonts, fontWeights } from '../styles/fonts';
import { content } from '../constants/content';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfUse from './TermsOfUse';

function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const handlePrivacyClick = (e) => {
    e.preventDefault();
    setShowPrivacy(true);
  };

  const handleTermsClick = (e) => {
    e.preventDefault();
    setShowTerms(true);
  };

  return (
    <>
      <footer style={styles.footer}>
        <div style={styles.logoContainer}>
         
        </div>
        
        <p style={styles.copyright}>{content.footer.copyright}</p>
        
        <div style={styles.links}>
          <a href="#privacy" style={styles.link} onClick={handlePrivacyClick}>
            Privacy Policy
          </a>
          <a href="terms" style={styles.link} onClick={handleTermsClick}>
            Terms of Use
          </a>
        </div>
      </footer>

      {showPrivacy && <PrivacyPolicy onClose={() => setShowPrivacy(false)} />}
      {showTerms && <TermsOfUse onClose={() => setShowTerms(false)} />}
    </>
  );
}

const styles = {
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'left',
    padding: '30px 60px',
    backgroundColor: '#1a1f2e',
    width: '100%',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'left',
  },
  logoCircle: {
    width: '48px',
    height: '48px',
    backgroundColor: '#2a3142',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'center',
    fontSize: '24px',
  },
  copyright: {
    fontSize: '14px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: '#9ca3af',
    margin: 0,
  },
  links: {
    display: 'flex',
    gap: '40px',
  },
  link: {
    fontSize: '14px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.white,
    textDecoration: 'none',
    cursor: 'pointer',
  },
};

export default Footer;